import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onSuggestedFilterSelected = ({
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
}: {
	actionSubjectId: string;
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'track',
	action: 'selected',
	actionSubject: 'suggestedFilter',
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
});
